import { lazy } from 'react'

/**
 * lazyRetry — React.lazy with one-shot recovery from stale-deploy chunk 404s.
 *
 * The build content-hashes every chunk, so after a frontend redeploy an
 * already-open tab (old index.html) references chunk names that no longer
 * exist — `Failed to fetch dynamically imported module` and the whole tree
 * crashes. Recovery: reload once (fresh index.html -> new hashes) and clear
 * the guard on any success. If the retry fails too, rethrow into the
 * ErrorBoundary instead of looping.
 */
const RETRY_FLAG = 'cfd_chunk_reload'

function clearFlag() {
    try { sessionStorage.removeItem(RETRY_FLAG) } catch { /* private mode */ }
}

export function lazyRetry(importer) {
    return lazy(() =>
        importer()
            .then((mod) => { clearFlag(); return mod })
            .catch((err) => {
                let flagged = false
                try { flagged = sessionStorage.getItem(RETRY_FLAG) !== null } catch { /* private mode */ }
                if (flagged) {
                    clearFlag()
                    throw err
                }
                try { sessionStorage.setItem(RETRY_FLAG, String(Date.now())) } catch { /* private mode */ }
                window.location.reload()
                // Unreachable in practice (page reloads); satisfies the promise.
                return { default: () => null }
            })
    )
}
